// Generated by purs version 0.15.16
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Record from "../Record/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var coursesIsSymbol = {
    reflectSymbol: function () {
        return "courses";
    }
};
var modify = /* #__PURE__ */ Record.modify(coursesIsSymbol)()();
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var type_idIsSymbol = {
    reflectSymbol: function () {
        return "type_id";
    }
};
var rename = /* #__PURE__ */ Record.rename({
    reflectSymbol: function () {
        return "form";
    }
})(type_idIsSymbol)()()()();
var allowed_typesIsSymbol = {
    reflectSymbol: function () {
        return "allowed_types";
    }
};
var rename1 = /* #__PURE__ */ Record.rename({
    reflectSymbol: function () {
        return "types";
    }
})(allowed_typesIsSymbol)()()()();
var rntyType = /* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "ID";
    }
});
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var teacher_idIsSymbol = {
    reflectSymbol: function () {
        return "teacher_id";
    }
};
var hqtMaybe = /* #__PURE__ */ GraphQL_Type.hqtMaybe(rntyType);
var encodeJsonMaybe = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(encRNTY);
var student_idIsSymbol = {
    reflectSymbol: function () {
        return "student_id";
    }
};
var position_idIsSymbol = {
    reflectSymbol: function () {
        return "position_id";
    }
};
var employer_idIsSymbol = {
    reflectSymbol: function () {
        return "employer_id";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var contact_idIsSymbol = {
    reflectSymbol: function () {
        return "contact_id";
    }
};
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)));
var gDecodeJsonCons2 = /* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var positionsIsSymbol = {
    reflectSymbol: function () {
        return "positions";
    }
};
var deleted_atIsSymbol = {
    reflectSymbol: function () {
        return "deleted_at";
    }
};
var contactsIsSymbol = {
    reflectSymbol: function () {
        return "contacts";
    }
};
var companyIsSymbol = {
    reflectSymbol: function () {
        return "company";
    }
};
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString));
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var default_last_nameIsSymbol = {
    reflectSymbol: function () {
        return "default_last_name";
    }
};
var default_first_nameIsSymbol = {
    reflectSymbol: function () {
        return "default_first_name";
    }
};
var default_emailIsSymbol = {
    reflectSymbol: function () {
        return "default_email";
    }
};
var signature_fieldsIsSymbol = {
    reflectSymbol: function () {
        return "signature_fields";
    }
};
var employerIsSymbol = {
    reflectSymbol: function () {
        return "employer";
    }
};
var dataIsSymbol = {
    reflectSymbol: function () {
        return "data";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var maybeShape = /* #__PURE__ */ GraphQL_Shape.maybeShape(GraphQL_Shape.scalarShape);
var CoursesAF = /* #__PURE__ */ (function () {
    function CoursesAF() {

    };
    CoursesAF.value = new CoursesAF();
    return CoursesAF;
})();
var StudentAF = /* #__PURE__ */ (function () {
    function StudentAF() {

    };
    StudentAF.value = new StudentAF();
    return StudentAF;
})();
var TeacherAF = /* #__PURE__ */ (function () {
    function TeacherAF() {

    };
    TeacherAF.value = new TeacherAF();
    return TeacherAF;
})();
var EmployerAF = /* #__PURE__ */ (function () {
    function EmployerAF() {

    };
    EmployerAF.value = new EmployerAF();
    return EmployerAF;
})();
var ContactAF = /* #__PURE__ */ (function () {
    function ContactAF() {

    };
    ContactAF.value = new ContactAF();
    return ContactAF;
})();
var PositionAF = /* #__PURE__ */ (function () {
    function PositionAF() {

    };
    PositionAF.value = new PositionAF();
    return PositionAF;
})();
var NowAF = /* #__PURE__ */ (function () {
    function NowAF() {

    };
    NowAF.value = new NowAF();
    return NowAF;
})();
var initAutofillArgs = function (form) {
    return function (student_id) {
        return {
            form: form,
            student_id: student_id,
            teacher_id: Data_Maybe.Nothing.value,
            employer_id: Data_Maybe.Nothing.value,
            position_id: Data_Maybe.Nothing.value,
            contact_id: Data_Maybe.Nothing.value,
            courses: [  ],
            types: [  ]
        };
    };
};
var autofillTypeStr = function (v) {
    if (v instanceof CoursesAF) {
        return "COURSES";
    };
    if (v instanceof StudentAF) {
        return "STUDENT";
    };
    if (v instanceof TeacherAF) {
        return "TEACHER";
    };
    if (v instanceof EmployerAF) {
        return "EMPLOYER";
    };
    if (v instanceof ContactAF) {
        return "CONTACT";
    };
    if (v instanceof PositionAF) {
        return "POSITION";
    };
    if (v instanceof NowAF) {
        return "NOW";
    };
    throw new Error("Failed pattern match at API.Autofill (line 35, column 1 - line 35, column 42): " + [ v.constructor.name ]);
};
var aftQT = {
    gqlType: function (v) {
        return new GraphQL_Type.QType("AutofillType");
    }
};
var aftEq = {
    eq: function (x) {
        return function (y) {
            if (x instanceof CoursesAF && y instanceof CoursesAF) {
                return true;
            };
            if (x instanceof StudentAF && y instanceof StudentAF) {
                return true;
            };
            if (x instanceof TeacherAF && y instanceof TeacherAF) {
                return true;
            };
            if (x instanceof EmployerAF && y instanceof EmployerAF) {
                return true;
            };
            if (x instanceof ContactAF && y instanceof ContactAF) {
                return true;
            };
            if (x instanceof PositionAF && y instanceof PositionAF) {
                return true;
            };
            if (x instanceof NowAF && y instanceof NowAF) {
                return true;
            };
            return false;
        };
    }
};
var aftEnc = {
    encodeJson: /* #__PURE__ */ (function () {
        var $337 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
        return function ($338) {
            return $337(autofillTypeStr($338));
        };
    })()
};
var buildQuery = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil)(type_idIsSymbol)(rntyType)(encRNTY)()())(teacher_idIsSymbol)(hqtMaybe)(encodeJsonMaybe)()())(student_idIsSymbol)(rntyType)(encRNTY)()())(position_idIsSymbol)(hqtMaybe)(encodeJsonMaybe)()())(employer_idIsSymbol)(hqtMaybe)(encodeJsonMaybe)()())(coursesIsSymbol)(/* #__PURE__ */ GraphQL_Type.hqtArray(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "AutofillIDInput";
    }
})))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encRNTY)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "index";
    }
})())(idIsSymbol)())())))()())(contact_idIsSymbol)(hqtMaybe)(encodeJsonMaybe)()())(allowed_typesIsSymbol)(/* #__PURE__ */ GraphQL_Type.hqtArray(aftQT))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(aftEnc))()())(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil)(type_idIsSymbol)())(teacher_idIsSymbol)())(student_idIsSymbol)())(position_idIsSymbol)())(employer_idIsSymbol)())(coursesIsSymbol)())(contact_idIsSymbol)())(allowed_typesIsSymbol)())())(/* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonJson))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(nameIsSymbol)()())(idIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Internal_Luxon.decodeLDT))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(labelIsSymbol)()())(idIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(positionsIsSymbol)()())(idIsSymbol)()())(deleted_atIsSymbol)()())(contactsIsSymbol)()())(companyIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil)(keyIsSymbol)()())(default_last_nameIsSymbol)()())(default_first_nameIsSymbol)()())(default_emailIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(signature_fieldsIsSymbol)()())(employerIsSymbol)()())(dataIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(signature_fieldsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(default_last_nameIsSymbol)(maybeShape)()())(default_first_nameIsSymbol)(maybeShape)()())(default_emailIsSymbol)(maybeShape)()())()))()())(employerIsSymbol)(/* #__PURE__ */ GraphQL_Shape.maybeShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(positionsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(deleted_atIsSymbol)(maybeShape)()())(contactsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(companyIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(dataIsSymbol)(GraphQL_Shape.scalarShape)()())()));
var autofillData = function (args) {
    var renameArgs = (function () {
        var $339 = modify(Type_Proxy["Proxy"].value)(map(GraphQL_Type.namedType));
        var $340 = rename(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value);
        var $341 = rename1(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value);
        return function ($342) {
            return $339($340($341($342)));
        };
    })();
    return GraphQL_Query.nameQuery("AutofillForm")(buildQuery("autofillData")(renameArgs(args)));
};
export {
    CoursesAF,
    StudentAF,
    TeacherAF,
    EmployerAF,
    ContactAF,
    PositionAF,
    NowAF,
    autofillTypeStr,
    initAutofillArgs,
    autofillData,
    aftEq,
    aftEnc,
    aftQT
};
//# sourceMappingURL=index.js.map
